<script setup>
// TODO: migration to DVC scheduled for march 2024
const { t } = useI18n()

const dataBus = inject('dataBus', {})
const dataQuery = inject('dataQuery', {})
const maxVisibleButtons = 3

const startPage = computed(() => {
  const pagesBeforeCurrent = Math.floor(maxVisibleButtons / 2)
  return Math.max(1, currentPage.value - pagesBeforeCurrent)
})

const endPage = computed(() => {
  return Math.min(
    startPage.value + maxVisibleButtons - 1,
    totalPages.value,
  )
})

const pages = computed(() => {
  const range = []

  for (let i = startPage.value; i <= endPage.value; i += 1) {
    range.push({
      name: i,
      isDisabled: i === currentPage.value,
    })
  }

  return range
})

const isInFirstPage = computed(() => {
  return currentPage.value === 1
})

const isInLastPage = computed(() => {
  return currentPage.value >= totalPages.value
})

const totalPages = computed(() => {
  return dataQuery.value?.paging?.totalPages
})

const currentPage = computed(() => {
  return dataQuery.value?.paging?.currentPage
})

const perPage = computed(() => {
  return dataQuery.value?.paging?.perPage
})

function onClickFirstPage() {
  changePage(1)
}

function onClickPreviousPage() {
  changePage(currentPage.value - 1)
}

function onClickPage(page) {
  changePage(page)
}

function onClickNextPage() {
  changePage(currentPage.value + 1)
}

function onClickLastPage() {
  changePage(totalPages.value)
}

function isPageActive(page) {
  return currentPage.value === page
}

function changePage(page) {
  dataBus.value.emit('update:page', page)
}
</script>

<template>
  <div
    v-if="endPage > 1"
    class="flex"
  >
    <ul class="flex rounded bg-white shadow-sm">
      <li class="flex">
        <button
          type="button"
          :disabled="isInFirstPage"
          class="select-none border border-r-0 border-gray-100 rounded-l px-3 py-2 text-sm text-gray-600 no-underline hover:bg-surface-500 disabled:text-text-200"
          :class="{ 'cursor-not-allowed': isInFirstPage }"
          @click="onClickPreviousPage"
        >
          <i class="i-far-chevron-left" />
        </button>
      </li>

      <li
        v-for="page in pages"
        :key="page.name"
        class="flex"
      >
        <span
          v-if="isPageActive(page.name)"
          class="select-none border border-surface-700 bg-surface-500 px-3 py-2 text-sm color-text-heading no-underline hover:no-underline"
        >{{ page.name }}</span>
        <a
          v-else
          class="border border-surface-500 px-3 py-2 text-sm color-text-label hover:bg-surface-500 hover:no-underline"
          href="#"
          role="button"
          @click.prevent="onClickPage(page.name)"
        >{{ page.name }}</a>
      </li>

      <li class="flex">
        <button
          type="button"
          :disabled="isInLastPage"
          class="select-none border border-l-0 border-gray-100 rounded-r px-3 py-2 text-sm text-gray-600 no-underline hover:bg-surface-500 disabled:text-text-200"
          :class="{ 'cursor-not-allowed': isInLastPage }"
          @click="onClickNextPage"
        >
          <i class="i-far-chevron-right" />
        </button>
      </li>
    </ul>
  </div>
</template>
